// Tracks which cards THIS TAB has reacted to, purely for the UI's "active"
// highlight — the server is the real source of truth (keyed by visitorId,
// see retroVisitor.js). sessionStorage, not localStorage: two tabs on the
// same computer must not look like the same reactor.
const reactedKey = (boardId) => `retro-board-${boardId}-reacted`

export const loadReactedIds = (boardId) => {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(reactedKey(boardId)) || '[]'))
  } catch {
    return new Set()
  }
}

export const saveReactedIds = (boardId, reactedIds) => {
  sessionStorage.setItem(reactedKey(boardId), JSON.stringify([...reactedIds]))
}
